var render = function render(_c,_vm){return _c('div',{staticClass:"filter-item-position"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"filter-item-position__absoulte"},[_vm._t("position")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }